var _circle, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 71,
    viewBox: "0 0 58 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 44.5,
    r: 26.5,
    fill: "#FBE3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0367 10.7866C12.3931 10.8679 11.787 11.1345 11.2922 11.554C7.89946 14.2287 5.15807 17.6386 3.27468 21.5267C1.39128 25.4148 0.415013 29.6797 0.419449 34C0.419449 49.7448 13.2508 62.5828 29.0001 62.5828C44.7493 62.5828 57.5829 49.7448 57.5829 34C57.5829 24.9141 53.34 16.7851 46.7079 11.5518C46.0145 10.9971 45.1292 10.7406 44.2467 10.8387C43.3642 10.9368 42.5568 11.3815 42.0021 12.0749C41.4474 12.7683 41.1909 13.6536 41.2891 14.5361C41.3872 15.4186 41.8318 16.226 42.5252 16.7807C45.134 18.8287 47.2427 21.4432 48.692 24.4264C50.1413 27.4096 50.8931 30.6834 50.8906 34C50.8977 36.8767 50.3363 39.7264 49.2387 42.3855C48.1411 45.0446 46.5289 47.4606 44.4948 49.4947C42.4606 51.5288 40.0446 53.141 37.3856 54.2386C34.7265 55.3362 31.8768 55.8976 29.0001 55.8905C26.1234 55.8976 23.2736 55.3362 20.6146 54.2386C17.9555 53.141 15.5395 51.5288 13.5054 49.4947C11.4712 47.4606 9.85906 45.0446 8.76146 42.3855C7.66386 39.7264 7.10246 36.8767 7.10953 34C7.10953 26.9998 10.391 20.7938 15.4749 16.7807C16.0657 16.337 16.493 15.7102 16.6901 14.9981C16.8873 14.2861 16.8432 13.5288 16.5648 12.8444C16.2864 12.16 15.7894 11.587 15.1511 11.2147C14.5129 10.8425 13.7694 10.692 13.0367 10.7866Z",
    fill: "#710D0D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 6,
    height: 35,
    rx: 3,
    fill: "#710D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.f2f9d78d4bfcfe4884e18ee3cb334bd1.svg";
export { ForwardRef as ReactComponent };